import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[click-stop-propagation]'
    //events: 'stopClick($event)'
})

export class ClickStopPropagation {
    constructor() {
    }

    //https://coryrylan.com/blog/creating-a-custom-debounce-click-directive-in-angular
    //https://netbasal.com/implementing-event-modifiers-in-angular-87e1a07969ce
    @HostListener('click', ['$event'])
    clickEvent(event) {
        event.preventDefault();
        event.stopPropagation();
    }
}
